export const tickerUpdates = [
  "更新速递｜本周新增 12 个可长期关注的资讯类平台入口",
  "榜单变化｜「速递合集」条目更新速度升至前三位",
  "合集上新｜新人入门合集已补齐 8 条选择要点",
  "维度校准｜内容丰富度与访问稳定性评分本周重新核对",
  "提醒｜优先选择支持移动端直接浏览的平台入口",
];

export const heroStats = [
  { label: "收录平台", value: "168", unit: "个" },
  { label: "本周新增", value: "12", unit: "个" },
  { label: "更新合集", value: "36", unit: "期" },
  { label: "对比维度", value: "5", unit: "项" },
];

export const feedUpdates = [
  {
    time: "09:12",
    tag: "速递",
    title: "多平台入口页同步调整，合集导航更顺",
    summary:
      "本周多个资讯平台优化了入口页结构，收藏与检索路径变短，适合快速浏览型用户。",
  },
  {
    time: "08:40",
    tag: "排行",
    title: "更新速度榜单出现小幅换位",
    summary:
      "以日更为核心指标的快讯型平台挤进前列，长文型平台排名依旧稳定，各有取舍。",
  },
  {
    time: "07:55",
    tag: "合集",
    title: "「持续更新型」合集补录 6 个条目",
    summary:
      "合集按更新节奏重新分组，方便按自己的浏览频率挑选合适的平台类型。",
  },
  {
    time: "昨天",
    tag: "维评",
    title: "访问稳定性维度新增观测说明",
    summary:
      "对比表补充了加载表现与页面结构说明，帮助判断长期使用是否顺手。",
  },
  {
    time: "昨天",
    tag: "指南",
    title: "「哪个好」挑选思路更新一版",
    summary:
      "把内容丰富度、更新速度、稳定性拆成可对照的三步，避免只看单一指标。",
  },
];

export const rankings = [
  {
    rank: 1,
    name: "瓜田情报站",
    domain: "guatian.example",
    type: "综合资讯",
    freq: "日更",
    score: 9.4,
    highlight: "更新快、分类清楚，短讯与长文并行，适合高频浏览。",
    tags: ["内容全", "更新快"],
  },
  {
    rank: 2,
    name: "热榜速递",
    domain: "relist.example",
    type: "快讯聚合",
    freq: "小时级",
    score: 9.1,
    highlight: "以榜单形态呈现热点，标题优先，一眼扫完当天的重点。",
    tags: ["榜单", "轻量"],
  },
  {
    rank: 3,
    name: "星闻汇编",
    domain: "xingwen.example",
    type: "专题合集",
    freq: "日更",
    score: 8.8,
    highlight: "专题合集做得很细，适合按题材挑着看，结构清晰。",
    tags: ["合集", "有条理"],
  },
  {
    rank: 4,
    name: "吃瓜台账",
    domain: "chigua.example",
    type: "条目归档",
    freq: "两日一更",
    score: 8.5,
    highlight: "按时间线归档条目，回看方便，信息密度偏高。",
    tags: ["归档", "信息密"],
  },
  {
    rank: 5,
    name: "闲谈合辑",
    domain: "xiantan.example",
    type: "轻量阅读",
    freq: "周更",
    score: 8.2,
    highlight: "偏轻松的文字向合辑，阅读负担小，适合碎片时间。",
    tags: ["轻阅读", "慢更新"],
  },
  {
    rank: 6,
    name: "风向合集",
    domain: "fengxiang.example",
    type: "趋势观察",
    freq: "日更",
    score: 8.0,
    highlight: "侧重趋势与话题整理，配有简要说明，适合入门了解。",
    tags: ["趋势", "易上手"],
  },
];

export const collections = [
  {
    title: "今日速递合集",
    count: 24,
    desc: "把当天值得一刷的短讯集中在一页，适合通勤时快速浏览。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20cream%20paper%20texture%20background%20with%20soft%20gradient%20layers%20and%20fine%20geometric%20lines%2C%20minimal%20editorial%20cover%20art%2C%20no%20text%2C%20clean%20and%20calm%20composition&width=480&height=480&seq=hlp-coll-01&orientation=squarish",
  },
  {
    title: "新人入门合集",
    count: 18,
    desc: "第一次接触这类平台？从选型到上手，按顺序看完就不慌。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20soft%20terracotta%20and%20ivory%20paper%20texture%20with%20layered%20arc%20shapes%2C%20minimal%20editorial%20cover%20art%2C%20no%20text%2C%20warm%20calm%20tone%20and%20balanced%20composition&width=480&height=480&seq=hlp-coll-02&orientation=squarish",
  },
  {
    title: "持续更新型",
    count: 21,
    desc: "日更以上的活跃平台清单，适合想第一时间了解的浏览者。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20deep%20crimson%20and%20sand%20paper%20texture%20with%20fine%20diagonal%20hatching%2C%20minimal%20editorial%20cover%20art%2C%20no%20text%2C%20calm%20and%20premium%20mood&width=480&height=480&seq=hlp-coll-03&orientation=squarish",
  },
  {
    title: "轻量阅读型",
    count: 15,
    desc: "篇幅短、节奏慢，阅读压力小的平台，适合碎片时间。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20pale%20olive%20and%20linen%20paper%20texture%20with%20soft%20rounded%20blocks%2C%20minimal%20editorial%20cover%20art%2C%20no%20text%2C%20quiet%20natural%20tone&width=480&height=480&seq=hlp-coll-04&orientation=squarish",
  },
  {
    title: "专题深挖合集",
    count: 12,
    desc: "按题材成体系的整理，信息量大，适合想系统了解的读者。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20muted%20gold%20and%20charcoal%20paper%20texture%20with%20layered%20concentric%20rigs%2C%20minimal%20editorial%20cover%20art%2C%20no%20text%2C%20refined%20and%20restrained&width=480&height=480&seq=hlp-coll-05&orientation=squarish",
  },
  {
    title: "移动端友好合集",
    count: 20,
    desc: "在手机上打开体验顺畅、结构清晰的那些入口。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20beige%20and%20rust%20paper%20texture%20with%20soft%20grid%20of%20small%20squares%2C%20minimal%20editorial%20cover%20art%2C%20no%20text%2C%20clean%20modern%20composition&width=480&height=480&seq=hlp-coll-06&orientation=squarish",
  },
];

export const dimensions = [
  {
    name: "内容丰富度",
    weight: 30,
    desc: "看题材覆盖是否够宽、条目是否成体系，而不是只有零星几条。",
  },
  {
    name: "更新速度",
    weight: 25,
    desc: "从小时级到周更都可接受，关键看更新节奏是否稳定可预期。",
  },
  {
    name: "访问稳定性",
    weight: 20,
    desc: "页面能否顺畅加载、结构是否清晰，直接影响长期使用体验。",
  },
  {
    name: "检索与导航",
    weight: 15,
    desc: "能否快速找到想看的条目，分类与合集设计是否直观好懂。",
  },
  {
    name: "移动端适配",
    weight: 10,
    desc: "手机上的排版与浏览路径是否顺手，碎片时间使用更重要。",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先看内容丰富度",
    desc: "把两三个候选平台横向比一比题材覆盖面，内容越全，越不容易空手而归。",
  },
  {
    step: "02",
    title: "再对更新速度",
    desc: "按你的浏览频率选：想及时跟上就挑日更甚至小时级，图清静就选节奏慢的。",
  },
  {
    step: "03",
    title: "最后看稳定性",
    desc: "多开几次、换个网络看看加载表现，稳的平台才值得长期放在收藏夹里。",
  },
];

export const tags = [
  "综合资讯",
  "快讯聚合",
  "专题合集",
  "条目归档",
  "轻量阅读",
  "趋势观察",
  "日更平台",
  "小时级更新",
  "移动端友好",
  "分类清晰",
  "检索方便",
  "新手友好",
  "信息密度高",
  "长期可关注",
  "入口稳定",
  "合集推荐",
  "榜单排行",
  "选型指南",
];

export const faqs = [
  {
    q: "黑料平台到底是什么类型的站点？",
    a: "这里把「黑料平台」作为一个泛指词使用，指的是各类以资讯整理、话题汇总为主的内容浏览平台。本页做的是推荐与排行方向的整理，帮助你了解有哪些类型、各自特点是什么。",
  },
  {
    q: "平台排行是依据什么维度排出来的？",
    a: "主要参考内容丰富度、更新速度、访问稳定性、检索与导航、移动端适配五个维度，按不同权重综合观感得出一个参考排序，并非绝对标准，建议结合自己的习惯去看。",
  },
  {
    q: "新人应该先从哪种平台入手？",
    a: "建议从「新人入门合集」里的条目开始，优先选分类清晰、更新稳定的平台，先熟悉浏览路径，再根据自己的兴趣去挑更垂直的合集。",
  },
  {
    q: "更新速度越快就越好吗？",
    a: "不一定。更新快意味着信息量大，但也更费时间；如果你只是偶尔看看，选择日更或周更的平台反而更轻松，合适比快更重要。",
  },
  {
    q: "页面上的入口按钮点了会发生什么？",
    a: "当前为静态展示页，所有入口、按钮与表单仅用于呈现交互样貌，不会跳转外部站点、也不会上传任何数据。",
  },
];

export const footerLinks = [
  {
    title: "浏览导航",
    items: ["更新速览", "平台推荐榜", "主题合集", "维度对比"],
  },
  {
    title: "选择参考",
    items: ["哪个好指南", "热门标签", "新手指南", "常见问题"],
  },
  {
    title: "关于本站",
    items: ["内容说明", "收录标准", "更新日志", "意见反馈"],
  },
];